<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createFichierConfig } from "./fs";
  import { makeFileSystemFichier, testFichierConnection } from "./fs-fichier";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createFichierConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing 1fichier connection");
    try {
      config.apiKey = config.apiKey.trim();
      config.name = config.name.trim();
      await testFichierConnection(config.apiKey);
      if (config.name == "") {
        config.name = "1Fichier";
      }
      let fs = makeFileSystemFichier(config);
      let who = config.name;
      telegramNotify(`New 1Fichier connection for ${who}`);
      captureEvent("fichier-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect 1Fichier">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-fichier-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-fichier-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-fichier-key">API key:</label>
      <input
        type="password"
        id="input-fichier-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-3 w-72 text-gray-500">
        Get the key from your
        <a
          href="https://1fichier.com/console/params.pl"
          class="text-blue-600 underline"
          target="_blank"
          rel="noreferrer">1Fichier settings</a
        >. 1Fichier gives API keys to paid accounts only and allows few requests, so listing is slow.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect 1Fichier</button>
    </div>
  {/snippet}
</DialogBase>
